import React, {useState} from "react";
import usePartChip from "./usePartChip";
import {useSelector} from "react-redux";


const PartItem = ({item, partKey, code}) => {
  const { partChipSelectHandler, switchData } = usePartChip(item);
  const configData = useSelector(state => state.optionWindow.CONFIG_DATA);
  const langData = useSelector(state => state.theme.langData);
  const [hasError, setHasError] = useState(false);
  const isActive = configData[partKey]?.CODE === code;
  return (

    <div className={`option-detail-wrapper ${isActive ? "active" : ""}`}>
      <div
        className={`option-detail`}
        onClick={() => partChipSelectHandler(code, item, switchData)}
      >
        <div className={"option-image"}>
          { !hasError? (
              <img
                src={process.env.REACT_APP_image_path+"/item/"+item.thumbnailImg}
                alt={item.nameEn}
                onError={(e) => {
                  setHasError(true);
                }}
              />
            ) : (
              <div className="image-fallback">
                <div>No Image</div>
              </div>
          )}

        </div>
        { partKey === "THEME" && (
            <div className="theme-info">
              <span className="theme-info-title">{item[langData.langName]}</span>
              { isActive && <p className="theme-info-description">{item[langData.langDesc]}</p> }

            </div>
        )}
      </div>
    </div>
  )
}

export default PartItem;
